module.exports = __webpack_public_path__ + "img/image-4.5bbd4783.jpg";